



















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component
export default class GraphDialog extends Vue {
  public toggleComparisonFlag: boolean = false
  private defaultDate: string = '-月-日'
  private comparisonDate: string = '-月-日'
  private masterDate: string = '-月-日'
  private graphData: {[key: string]: number|null} = {
    growth_height: null,
    integration_temperature: null,
    soil_moisture: null,
    spad: null,
    stem_number: null
  }
  private masterData: {[key: string]: number|null} = {
    growth_height: null,
    integration_temperature: null,
    soil_moisture: null,
    spad: null,
    stem_number: null
  }
  private comparisonData: {[key: string]: number|null} = {
    growth_height: null,
    integration_temperature: null,
    soil_moisture: null,
    spad: null,
    stem_number: null
  }

  @Prop() growthData!: any

  /* computed */
  private get growthList (): any {
    return this.$store.state.stageUpdateState.defaultStageData
  }
  private get setGraphDialogFlag () : boolean {
    return this.$store.state.setFlagState.graphDialogFlag
  }

  @Watch('growthList')
  updateList (newValue: any) {
    this.createdDialogData()
  }
  @Watch('setGraphDialogFlag')
  setGraphDate (flag: boolean) {
    this.createdDialogData()
  }

  created () {
    if (this.$store.state.graphToggleState.showComparison) {
      this.getComparisonData()
    }
  }

  mounted () {
    if (this.$store.state.setFlagState.graphDialogFlag) {
      this.createdDialogData()
    }
  }

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? value : '-'
  }

  private createdDialogData () {
    const plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (this.growthData.days * 24 * 60 * 60 * 1000))
    let keyDate = '' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate())
    this.defaultDate = keyDate.slice(4, 6) + '月' + keyDate.slice(6, 8) + '日'

    this.getGprahData(keyDate)
    this.getMasterData(this.growthData.id)

    if (!this.$store.state.graphToggleState.hiddenComparisonData) {
      this.toggleComparisonFlag = true
      this.getComparisonData()
    } else {
      this.toggleComparisonFlag = false
    }

    this.$store.commit('setFlagState/setGraphDialogFlag', false)
  }

  private getGprahData (keyDate: string) {
    let graphData = JSON.parse(Session.getGraphData()!)

    for (var key in graphData) {
      if (key === keyDate) {
        this.graphData = graphData[key]
      }
    }
  }

  private getMasterData (id: number) {
    let masterData = JSON.parse(Session.getMasterData()!)
    let count = 1

    for (var i in masterData) {
      if (count === this.growthData.growth_step) {
        this.masterDate = i.slice(4, 6) + '月' + i.slice(6, 8) + '日'
        this.masterData = masterData[i]
      }
      count++
    }
  }

  private getComparisonData () {
    let step = this.growthData.growth_step
    let comparisonGraphData = JSON.parse(Session.getComparisonData()!)
    let comparisonStage = JSON.parse(Session.getComparisonStageData()!)
    let comparisonData = JSON.parse(Session.getComparisonPredictionData()!)

    for (var key in comparisonStage) {
      if (step === comparisonStage[key].growth_step) {
        let day = Object.keys(comparisonGraphData)[comparisonStage[key].days]
        // 実績があれば比較実績、なければ比較目標を表示
        if (day === undefined) {
          let count = 1
          for (var i in comparisonData) {
            if (count === this.growthData.growth_step) {
              this.comparisonDate = i.slice(4, 6) + '月' + i.slice(6, 8) + '日'
              this.comparisonData = comparisonData[i]
            }
            count++
          }
        } else {
          this.comparisonDate = day.slice(4, 6) + '月' + day.slice(6, 8) + '日'
          this.comparisonData = comparisonGraphData[day]
          this.comparisonData.elapsed_days = this.fixElapsedDays(comparisonGraphData[day].elapsed_days)
        }
      }
    }

    this.toggleComparisonFlag = true
  }

  private fixElapsedDays (days: number) {
    return days - 1
  }
}
